import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import Sortable, { ReactSortable } from "react-sortablejs";

import { H2 } from "components/atoms/text";
import COLORS from "components/atoms/colors";
import ItemContent from "components/templates/project/SideBar/Library/ItemContent";
import ItemCreate from "components/templates/project/SideBar/Library/ItemCreate";

import Scene from "types/Scene";

import useProject from "apis/queries/project/useProject";
import useEditScenePosition from "apis/mutations/scene/useEditScenePosition";

interface Props {
  onChangeSceneIndex: (i: number) => void;
}

// 라이브러리 탭
const Library = ({ onChangeSceneIndex }: Props) => {
  const params = useParams();

  // 드래그 앤 드롭 목록 상태
  // const [scenes, setScenes] = useState<Scene[]>([]);

  // 씬 목록 api
  const projectId = Number(params.id);
  const { project } = useProject({ projectId });

  // 드래그 앤 드롭 기능 - 기획에서 제외
  // useEffect(() => {
  //   if (project) {
  //     setScenes(project.scenes);
  //   }
  // }, [project]);

  // const editScenePoisition = useEditScenePosition(projectId);

  // const handleSort = (evt: Sortable.Sortable.SortableEvent) => {
  //   const updatedList = [...scenes];

  //   updatedList.splice(
  //     evt.newIndex as number,
  //     0,
  //     updatedList.splice(evt.oldIndex as number, 1)[0]
  //   );

  //   const data = updatedList.map((item, index) => ({
  //     sceneId: item.id,
  //     position: index + 1,
  //   }));

  //   editScenePoisition({ data });
  // };

  if (!project) return null;

  return (
    <div className="flex flex-col h-full">
      <div className="flex-none">
        <H2 className="mt-5 mb-5 px-5 text-primary-active !leading-[34px]">
          Scene Library
        </H2>
        <Item>
          <ItemCreate
            projectId={projectId}
            scenes={project.scenes}
            position={(project.scenes.at(-1)?.position || 0) + 1}
          />
        </Item>
      </div>
      <div className="flex-1 overflow-y-auto">
        {/* 드래그앤드롭 목록 */}
        {/* {scenes && (
          <ReactSortable list={scenes} setList={setScenes} onSort={handleSort}>
            {scenes.map((scene, index) => (
              <Item key={scene.id} onClick={() => onChangeSceneIndex(index)}>
                <ItemContent index={index} scene={scene} />
              </Item>
            ))}
          </ReactSortable>
        )} */}
        {project.scenes.map((scene, index) => (
          <Item key={scene.id} onClick={() => onChangeSceneIndex(index)}>
            <ItemContent index={index} scene={scene} />
          </Item>
        ))}
      </div>
    </div>
  );
};

const Item = styled.div`
  position: relative;
  display: flex;
  gap: 12px;
  border-bottom: 1px solid ${COLORS.white["60%"]};
  padding: 12px 0;
  margin: 0 20px;
  cursor: pointer;
  z-index: 1;

  &:hover {
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: calc(100% + 40px);
      top: 0;
      left: -20px;
      height: 100%;
      background-color: ${COLORS.white["60%"]};
      z-index: -1;
    }
  }
`;

export default Library;
